const AreYouThePatient = {
  areYouThePatientQuestion: "Are you the patient?",
  areYouThePatientChoice1: "yes",
  areYouThePatientChoice2: "no"
};

export default AreYouThePatient;
